<template>
  <div class="app-success">
    <slot name="txtHeader"><h2>Success</h2></slot>
    <slot name="txtBefore">Success</slot>
    <div v-if="!isProcessOrder && !isActivated"><slot name="txtAlreadyActive">Success already active</slot></div>
    <div v-if="!isProcessOrder && isActivated"><slot name="txtActivated">Success activated</slot></div>
    <div v-if="isProcessOrder"><slot name="txtOrdered">Success ordered</slot></div>
    <b-form>
      <b-button @click="back" variant="primary"><slot name="btnPrev">zurück</slot></b-button>
    </b-form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import { BForm, BButton } from 'bootstrap-vue'
import { mapMutations } from 'vuex'

export const stepName = 'success'

export default {
  name: 'Success',
  components: { BButton, BForm },
  props: {
    prevStep: {
      type: String,
      required: true
    },
    isActivated: {
      type: Boolean,
      default: false
    },
    isProcessOrder: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations('substituteSimCard', [
      'changeStep'
    ]),
    back () {
      this.changeStep({ step: this.prevStep })
    }
  }
}
</script>
